// extracted by mini-css-extract-plugin
export default {"pi":"ProductImg_pi__GVrf6","piFallback":"ProductImg_piFallback__pha1E"};